var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-table',{key:_vm.tableKey,class:{ 'table-horizontal': _vm.horizontal },attrs:{"height":null,"size":"small","value":_vm.tableData,"columns":_vm.tableColumns,"stripe":false,"horizontal":_vm.horizontal}})
}
var staticRenderFns = []

export { render, staticRenderFns }